import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import {
  Card,
  CardHeader,
  CardTitle,
  Row,
  Col,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap'
import styled from 'styled-components'
import ReactCountryFlag from 'react-country-flag'
import { IntlContext } from '~/utility/context/Internationalization'

import loginImg from '~/assets/img/pages/login.png'
import '~/assets/scss/pages/authentication.scss'
import LoginJWT from './LoginJWT'

import Spinner from '~/components/@vuexy/spinner/Loading-spinner'
import Logo from '~/assets/img/logo/locasty-text.svg'

function Login() {
  const [langDropdown, setLangDropdown] = useState(false)
  const loading = useSelector(state => state?.auth?.loading)
  const intl = useIntl()

  const handleLangDropdown = () => setLangDropdown(prevState => !prevState)

  return (
    <Row className="m-0 justify-content-center">
      <Col
        sm="8"
        xl="7"
        lg="10"
        md="8"
        className="d-flex justify-content-center"
      >
        <Card className="bg-authentication login-card rounded-0 mb-0 w-100">
          <Row className="m-0">
            <Col
              lg="6"
              className="d-lg-block d-none text-center align-self-center px-1 py-0"
            >
              <img src={loginImg} alt="loginImg" />
            </Col>
            <Col lg="6" md="12" className="p-0">
              <LoadingIndicator loading={loading}>
                <Spinner />
              </LoadingIndicator>
              <Card className="rounded-0 mb-0 px-2 login-tabs-container">
                <LoginHeader>
                  <CardTitle>
                    <HeaderLogo src={Logo} alt="Locasty" />
                  </CardTitle>
                  <IntlContext.Consumer>
                    {context => {
                      const langArr = {
                        en: 'English',
                        br: 'Português',
                      }
                      return (
                        <Dropdown
                          tag="li"
                          className="dropdown-language nav-item ml-1"
                          isOpen={langDropdown}
                          style={{ listStyle: 'none' }}
                          toggle={handleLangDropdown}
                          data-tour="language"
                        >
                          <DropdownToggle tag="a" className="nav-link">
                            <ReactCountryFlag
                              className="country-flag"
                              countryCode={
                                context.state.locale === 'en'
                                  ? 'us'
                                  : context.state.locale
                              }
                              svg
                            />
                            <span className="d-sm-inline-block d-none text-capitalize align-middle ml-50">
                              {langArr[context.state.locale]}
                            </span>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              tag="a"
                              onClick={() => context.switchLanguage('en')}
                            >
                              <ReactCountryFlag
                                className="country-flag"
                                countryCode="us"
                                svg
                              />
                              <span className="ml-1">English</span>
                            </DropdownItem>
                            <DropdownItem
                              tag="a"
                              onClick={() => context.switchLanguage('br')}
                            >
                              <ReactCountryFlag
                                className="country-flag"
                                countryCode="br"
                                svg
                              />
                              <span className="ml-1">Português</span>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      )
                    }}
                  </IntlContext.Consumer>
                </LoginHeader>
                <p className="px-2 auth-title">
                  {intl.formatMessage({
                    id: 'Manage your locations fast and easily.',
                  })}
                </p>
                <TabContent activeTab={'1'}>
                  <TabPane tabId="1">
                    <LoginJWT />
                  </TabPane>
                </TabContent>
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  )
}

const LoginHeader = styled(CardHeader)`
  align-items: flex-start !important;
  padding-top: 40px !important;
  padding-bottom: 15px !important;
`

const LoadingIndicator = styled.div`
  display: ${({ loading }) => (loading ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 500;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;

  div {
    width: 64px;
    height: 64px;
  }
`

const HeaderLogo = styled.img`
  @media (max-width: 380px) {
    width: 150px;
  }
`

export default Login
